function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { v4 as uuidv4 } from "uuid";
import { ADD_NOTIFICATION, CLOSE_NOTIFICATION, CLOSE_UI_MODAL, END_REQUEST_LOADING, GET_TAB_VALUE, OPEN_UI_MODAL, PUSH_ROUTE, RESET_FORM_VALUES, START_REQUEST_LOADING, UPDATE_FORM_VALUE, UPDATE_TAB_VALUE } from "./types";
/**
 * Action to handle notification addition.
 */ export function addNotification(config) {
    return {
        type: ADD_NOTIFICATION,
        payload: _object_spread({
            id: uuidv4()
        }, config)
    };
}
/**
 * Action to handle notification closures.
 */ export function closeNotification(id) {
    return {
        type: CLOSE_NOTIFICATION,
        payload: id
    };
}
/**
 * Action to push to a different route.
 */ export function pushRoute(history, route) {
    var delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return {
        type: PUSH_ROUTE,
        payload: {
            history: history,
            route: route,
            delay: delay
        }
    };
}
export var startRequestLoading = function(payload) {
    return {
        type: START_REQUEST_LOADING,
        payload: payload
    };
};
export var endRequestLoading = function(payload) {
    return {
        type: END_REQUEST_LOADING,
        payload: payload
    };
};
export var openModalAction = function(payload) {
    return {
        type: OPEN_UI_MODAL,
        payload: payload
    };
};
export var closeModalAction = function() {
    var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "",
        payload: {}
    };
    return {
        type: CLOSE_UI_MODAL,
        payload: payload
    };
};
export var updateFormValue = function(payload) {
    return {
        type: UPDATE_FORM_VALUE,
        payload: payload
    };
};
export var resetFormValue = function(payload) {
    return {
        type: RESET_FORM_VALUES,
        payload: payload
    };
};
export var setTabValue = function(payload) {
    return {
        type: UPDATE_TAB_VALUE,
        payload: payload
    };
};
export var getTabValue = function(payload) {
    return {
        type: GET_TAB_VALUE,
        payload: payload
    };
};

//# sourceMappingURL=index.js.map